/**
 * Route for `referral-code-tracking` (FS-826). Registered via createRoute.
 * Root wires the route into `router.tsx` post prod-main land.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ReferralCodeTrackingPage } from "../features/referral-code-tracking/ReferralCodeTrackingPage";

export const referralCodeTrackingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/referral-code-tracking",
	component: ReferralCodeTrackingPage,
});

export default referralCodeTrackingRoute;
